module.exports = __webpack_public_path__ + "img/Dutch.8047d83b.svg";